// extracted by css-extract-rspack-plugin
export default {"egovModal":"EgovPrepareModal__egovModal--ZgY4b","attachmentField":"EgovPrepareModal__attachmentField--P702b"};